import {createContext, useContext} from 'react';

type RouterContext =
  | {
      isAvailabiltyRoute: boolean;
      isRescheduleRoute?: boolean;
    }
  | {
      isAvailabiltyRoute?: boolean;
      isRescheduleRoute: boolean;
    };

const RouterContext = createContext<RouterContext | null>(null);

export const RouteProvider = ({
  isAvailabiltyRoute = false,
  isRescheduleRoute = false,
  children,
}: RouterContext & {children: React.ReactElement | React.ReactElement[]}) => {
  return (
    <RouterContext.Provider value={{isRescheduleRoute, isAvailabiltyRoute}}>
      {children}
    </RouterContext.Provider>
  );
};

export const useRouteContext = () => {
  const context = useContext(RouterContext);
  if (context === null) {
    throw new Error('useRouteContext must be used within a RouteProvider');
  }
  return context;
};
